import { create } from "../../../common/utils/zustand_state_manager";
import { useControleDocumentosRepositories } from "./use_repositories";
import { IGetDashboardControleDocumentosInformationUseCase } from '../../../features/controleDocumentos/presentation/useCases/read/get_dashboard_controle_documentos_information_use_case';
import { GetDashboardControleDocumentosInformationUseCase } from '../../../features/controleDocumentos/domain/useCases/read/get_dashboard_controle_documentos_information_use_case'; // {{ LAST DECL IMPORT }};

/**
 * useControleDocumentosUseCases
 */

export type ControleDocumentosState = {
  getDashboardControleDocumentosInformationUseCase: IGetDashboardControleDocumentosInformationUseCase, // {{ LAST DECL INTERFACE }}
};

export const useControleDocumentosUseCases = create<ControleDocumentosState>((set, get) => {
  const { controleDocumentosRepository: repository } = useControleDocumentosRepositories.getState()
  return ({
    getDashboardControleDocumentosInformationUseCase: new GetDashboardControleDocumentosInformationUseCase(repository), // {{ LAST DECL IMPLEMENTATION }}
  });
});